<template>
  <div id="sign-3" v-show="show">
    <!-- 签到开始 -->
    <div class="actModules">
      <h3 class="actModules_title" data-editText="true" data-field="modulesTitle">
        {{ modulesTitle }}
      </h3>
      <p
        class="actModules_descripe"
        data-editText="true"
        data-field="modulesRules"
        v-html="modulesRules"
      ></p>
      <div class="actModules_btnWrap">
        <div class="actModules_textItems">
          累计签到：
          <span>x</span>天
        </div>
        <div class="actModules_btnItems">
          <a
            href="javascript:;"
            @click="signHandle(headBtnInfo[0].action, false)"
            class="actModules_btn"
            >{{ headBtnInfo[0].buttonName }}</a
          >
        </div>
      </div>
      <ul class="actSignIn_Wrap">
        <li
          class="actSignIn_List"
          :class="{ disabled: signStatus[index] }"
          v-for="(sign, index) in signOption"
          :key="index"
        >
          <div class="actSigned"><span>已签到</span></div>
          <p class="actSignIn_text" v-text="sign.iconName"></p>
          <div class="actSign_icon"><img :src="sign.image.value" alt="" /></div>
          <div>
            <a
              href="javascript:;"
              @click="signHandle(sign.action, true, index)"
              class="actSignIn_btn"
              >{{ sign.buttonName }}</a
            >
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import bus from '../../../bus';
export default {
	name: 'h5-sign-three',
	actConfig: {
		labels: {
			// 字段名称，用于显示在配置系统上，在正式环境会删除
			modulesTitle: '头部文案：',
			bgImg: '背景图片',
			modulesRules: '规则描述：',
			headBtnInfo: '功能按钮信息',
			tabItems: 'Tab',
			name: '名称',
			image: '图片',
			action: '动作',
			actionType: '动作类型', // 自定义动作类型，系统内置有 ams: ams动作， link: 跳转到外链
			buttonName: '按钮文案',
			iconName: '道具名称',
			iconNum: '道具数量',
			signs: '签到',
			showtype: '展示(1安卓,0 IOS)'
		}
	},
	props: {
		modulesTitle: {
			type: String,
			default: '模块名字',
			label: '标题'
		},
		modulesRules: {
			type: String,
			default: '活动规则：自定义文案',
			label: '详细说明'
		},
		headBtnInfo: {
			type: Array,
			default: function () {
				return [
					{
						action: {
							class: 'action',
							type: 'no', // ams link alert
							value: '' //
						},
						buttonName: '功能按钮'
					}
				];
			}
		},
		signs: {
			type: Array,
			default () {
				return [
					{
						image: {
							class: 'image',
							value:
                'https://game.gtimg.cn/images/tgclub/act/a20190404actConfigCenter/actInvite_list.png'
						},
						action: {
							class: 'action',
							type: 'no', // ams link alert
							value: '', //
							ruleId: ''
						},
						iconName: '道具名称',
						// iconNum: '888',
						buttonName: '功能按钮'
					},
					{
						image: {
							class: 'image',
							value:
                'https://game.gtimg.cn/images/tgclub/act/a20190404actConfigCenter/actInvite_list.png'
						},
						action: {
							class: 'action',
							type: 'no', // ams link alert
							value: '', //
							ruleId: ''
						},
						iconName: '道具名称',
						// iconNum: '888',
						buttonName: '功能按钮'
					},
					{
						image: {
							class: 'image',
							value:
                'https://game.gtimg.cn/images/tgclub/act/a20190404actConfigCenter/actInvite_list.png'
						},
						action: {
							class: 'action',
							type: 'no', // ams link alert
							value: '', //
							ruleId: ''
						},
						iconName: '道具名称',
						// iconNum: '888',
						buttonName: '功能按钮'
					}
				];
			}
		},
		showtype: {
			type: String,
			default: ''
		}
	},
	data () {
		return {
			signOption: this.signs,
			signStatus: [false, false, false],
			show: true
		};
	},
	mounted () {
		if (this.$actMode !== 'production') {
			return;
		}
		bus.$on('giftReceivedStatus', isGetedh5 => {
			console.log(isGetedh5);
			if (typeof isGetedh5 === 'undefined') {
				return;
			}
			for (let i = 0; i < this.signOption.length; i++) {
				let idx = this.signOption[i].action.ruleId;
				if (typeof isGetedh5['h' + idx] !== 'undefined') {
					if (isGetedh5['h' + idx][0] > 0 && isGetedh5['h' + idx][1] === '0') {
						this.$set(this.signStatus, i, true);
						// this.geted[i] = true
					} else {
						this.signStatus[i] = false;
					}
				} else {
					this.signStatus[i] = false;
				}
			}
		});
		bus.$on('showtype', val => {
			this.show = val === this.showtype;
		});
	},
	methods: {
		async signHandle ({ type, value }, val, index) {
			try {
				const { sPackageName } = await this.$doAction(type, value);
				if (val) {
					alert(`恭喜你获得了${sPackageName}，请到游戏中查收`);
					this.$set(this.signStatus, index, true);
				} else {
					console.log(sPackageName);
					// TODO: 暂时不写，后期优化使用
				}
			} catch (e) {
				console.log(e);
				alert(e.sMsg);
			}
		}
	}
};
</script>
<style lang="scss" scoped>
@import "../../assets/scss/common";
//组件 scss 变量（经常改动的）
.actSign_Wrap {
  @extend %clearfix;
  background: #d8d8d8;
  width: 7.3rem;
  margin: 0.34rem auto 0;
  padding: 0.5rem 0.12rem;
}

.actModules_btnItems,
.actModules_textItems {
  @extend %inline-block;
  margin: 0 0.4rem;
}

.actModules_textItems {
  font-size: 0.24rem;
  color: #4a4a4a;
}
.actSignIn_Wrap {
  width: 7.3rem;
  text-align: center;
  padding: 0.5rem 0.4rem;
  background: #d8d8d8;
  margin: 1rem auto 0;
}

.actSignIn_List {
  width: 1.6rem;
  @extend %inline-block;
  margin: 0 0.2rem;
  position: relative;
  &.disabled {
    .actSigned {
      @extend %block;
    }
  }
}

.actSigned {
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
  position: absolute;
  @extend %none;
  span {
    color: #fff;
    left: 50%;
    top: 50%;
    font-size: 0.2rem;
    position: absolute;
    transform: translate(-50%, -50%);
  }
}

.actSignIn_text {
  font-size: 0.22rem;
  color: #a4a4a4;
}

.actSign_icon {
  height: 1.2rem;
  width: 1.2rem;
  // background: url("../../assets/images/actInvite_list.png") no-repeat;
  // background-size: 1.2rem;
  border: 1px solid #000;
  margin: 0.1rem auto 0;
  img {
    width: 100%;
  }
}

.actSignIn_btn {
  width: 1.6rem;
  height: 0.6rem;
  line-height: 0.6rem;
  font-size: 0.28rem;
  color: #4a4a4a;
  @extend %block;
  text-align: center;
  background: #e27f7f;
  margin: 0.4rem auto 0;
}
</style>



// WEBPACK FOOTER //
// src/components/actModules/h5/templates/login/x-sign-three.vue